import { render, staticRenderFns } from "./NewTodo.vue?vue&type=template&id=cb8c8806&"
import script from "./NewTodo.vue?vue&type=script&lang=js&"
export * from "./NewTodo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports